import React, { useState } from 'react';
import Header from '../../components/home/customer-service/header';
import Channel from '../../components/home/customer-service/channel';
import Footer from '../../components/footer';

import { useDarkMode } from '../../components/darkmode/DarkModeContext';

const CustomerServicePage2 = () => {
  const { isDarkMode } = useDarkMode(); // Menyediakan status dark mode
  const [selectedChannel, setSelectedChannel] = useState(null);

  return (
    <div 
      className={`min-h-screen ${isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-black'}`}
      style={{ 
        backgroundImage: `url('https://telnet.net.id/assets/bg.png')`,
        backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
        backgroundBlendMode: 'overlay'
      }}
    >
      
      
      {/* Header */}
      <Header />

      {/* Channel Selection */}
      <div className="container mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h2 className={`text-3xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-black'}`}>Pilih Channel Support</h2>
          <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} max-w-2xl mx-auto`}>
            Kami menyediakan berbagai cara untuk menghubungi customer service. Pilih yang paling sesuai dengan kebutuhan Anda.
          </p>
        </div>

        {/* Channel Component */}
        <Channel />

      </div>  
      <Footer />
    </div>
  );
};

export default CustomerServicePage2;
